import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ApplicationNavigation from "constants/navigation/applicationNavigation";
import NavButtons from "components/Elements/NavButtons";
import NavDetails from "components/Elements/NavDetails";
import API from "helpers/api";
import { appPath, applicationListPath } from "helpers/routePaths";
import SiteTerminologyContent from "pages/Clients/Sites/SiteApplication/SiteTerminology/SiteTerminologyContent";

const noop = () => {};

// Super-admin editor for an Application template's terminology, per locale. It
// reuses the Site Terminology screen scoped to the application, wrapped in the
// same application-config breadcrumb + tab bar the sibling routes render.
const ApplicationTerminology = () => {
	const { id } = useParams();
	const { t } = useTranslation();
	const navigation = ApplicationNavigation(id);
	const [applicationName, setApplicationName] = useState("");

	useEffect(() => {
		let active = true;
		API.get(`/api/Applications/${id}/defaults`)
			.then((res) => {
				if (active && res?.status === 200) setApplicationName(res.data.name);
			})
			.catch(() => {});
		return () => {
			active = false;
		};
	}, [id]);

	return (
		<>
			<div className="topContainerCustomCaptions">
				<NavDetails
					staticCrumbs={[
						{
							id: 1,
							name: t("label.applications"),
							url: appPath + applicationListPath,
						},
						{ id: 2, name: applicationName },
					]}
				/>
			</div>
			<NavButtons
				navigation={navigation}
				applicationName={applicationName}
				current={t("title.details")}
			/>
			<SiteTerminologyContent
				state={{
					isReadOnly: false,
					details: { data: { application: { name: applicationName } } },
				}}
				dispatch={noop}
				scope={{ level: "application", id: Number(id) }}
			/>
		</>
	);
};

export default ApplicationTerminology;
